import React from 'react';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import Checkbox from '@material-ui/core/Checkbox';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import InputLabel from '@material-ui/core/InputLabel';
import Grid from '@material-ui/core/Grid';
import Fab from '@material-ui/core/Fab';
import Save from '@material-ui/icons/Save';
import Close from '@material-ui/icons/Close';
import Radio from '@material-ui/core/Radio';
import Autorenew from '@material-ui/icons/Autorenew';
import RadioButtonUncheckedIcon from '@material-ui/icons/RadioButtonUnchecked';
import RadioButtonCheckedIcon from '@material-ui/icons/RadioButtonChecked';
import RemoveCircle from '@material-ui/icons/RemoveCircle';
import Switch from '@material-ui/core/Switch';
import CircularProgress from '@material-ui/core/CircularProgress';

class Color extends React.Component {

  render() {
    return (
      <div className={ 'color' } style={{ background: this.props.value }}></div>
    );
  }
}

class TextFieldColor extends React.Component {

  state = {
    value: this.props.value
  }

  onChange = (e) => {
    this.setState({
      value: e.target.value
    })
    this.props.onChange(e.target.value)
  }

  render() {
    return (
      <div>
        <Color value={ this.state.value } />
        
        <TextField
          label={ this.props.label }
          value={ this.state.value }
          onChange={ this.onChange }
          margin="normal"
        />
      </div>
    );
  }

}

class Sepa extends React.Component {

  render() {
    return (
      <Grid item xs={12} style={{ borderTop: '1px solid #ccc', marginTop: '30px' }}>
        <Typography style={{ color: 'white' }} variant="h6">
          -
        </Typography>
      </Grid>
    );
  }
}

class InputFile extends React.Component {

  state = {
    value: '',
    file: this.props.value
  }

  onChange = (e) => {
    this.setState({
      value: e.target.value
    })
  }

  handleselectedFile = async(e) => {
    let file = await window.sdk.manager.upload(e.target.files[0])
    console.log('file', file)
    this.setState({
      file: file
    })
    this.props.onChange(file)
  }
  
  remove = async(e) => {
    this.setState({
      file: ''
    })
    this.props.onChange('')
  }

  render() {
    return (
      <div>
        <TextField
          id={ this.props.id }
          label={ this.props.label }
          type="file"
          variant="filled"
          onChange={ this.handleselectedFile }
        />
        <img style={{ maxWidth: '85px', maxHeight: '95px', minWidth: '85px', minHeight: '90px', border:'1px solid #aaa' }} src={ this.state.file } />
        { this.state.file &&
          <Fab style={{ marginTop: '-80px', marginLeft: '10px' }} onClick={ this.remove } color="grey" variant="extended">
            <RemoveCircle  />
            Supprimer
          </Fab>
        }
      </div>
    );
  }

}


export default class Form extends React.Component {

  playerColor = {
    controlbar: 'rgba(0, 0, 0, 0)',
    slider_buffer: 'rgba(0, 0, 0, 0.5)',
    slider_rail: 'rgba(255,255,255,0.3)',
    slider_progress: '#f2f2f2'
  }

  state = {
    data: {
      autostart: true,
      color: {
        p1: '#3f51b5',
        p2: '#7986cb',
        p3: '#303f9f',
        s1: '#c51162',
        s2: '#ff4081',
        s3: '#f50057',
        back: '#ffffff',
        txt: '#000000'
      },
      playerColor: Object.assign({}, this.playerColor),
      logo: {
        file: '',
        position: 'top-right'
      },
      image: '',
      sharing: {
        sites: []
      },
      buttons: {
        rewind: {
          enable: true,
          value: 10
        },
        forward: {
          enable: true,
          value: 10
        },
      },
      playbackRateControls: [0.5, 1, 1.5],
      synople: {
        typo: '',
        extraits: true,
        typo: '',
        typo_name: '',
        typo_size: '',
        typoe_size: '',
        speaker: true,
        speaker_color: '#000000',
        playerOnly: false,
        speaker_delay: 7,
        speaker_show_delay: 7,
        image_speaker: '',
        speaker_typo: '', 
        speaker_typo_name: '',
        speaker_color_txt: '#000000',
        speaker_padding: '15%',
        css: '',
        js: ''
      }
    },
    sharingSites: [false, false, false, false, false, false, false, false],
    isSharing: true,
    loading: true
  }

  shared = ['facebook', 'twitter', 'email', 'googleplus', 'linkedin', 'pinterest', 'reddit', 'tumblr']

  style = {
    flex: {
      display: 'flex'
    }
  }

  listeners = [];

  async componentDidMount() {
    let data = await window.sdk.manager.getCustom(this.props.type, window[this.props.type + 'Id']);
    if (this.props.type == 'program' && data == 'empty')
      data = await window.sdk.manager.getCustom('channel', window['channelId']);
    if (data == 'empty')
      data = {};
    this.state.data = Object.assign(this.state.data, data);
    this.setState({
      loading: false
    })

    this.listeners.push(window.sdk.on('needUpdatePreview', () => {
      let custom = Object.assign({}, this.state.data);
      custom.playbackRateControls = this.processPlaybackControlers(custom.playbackRateControls);
      window.sdk.emit('updatePreview', custom)
    }));

  }

  changeLogoPosition = (e) => {
    console.log(e.target.value)
    this.state.data.logo.position = e.target.value;
    this.forceUpdate();
  }

  onChangeSharing(index, value) {

    this.state.sharingSites[index] = value;
    this.forceUpdate();
    for (var i in this.state.sharingSites) {
      if (this.state.sharingSites[i]) {
        if (this.state.data.sharing.sites.indexOf(this.shared[i]) === -1)
          this.state.data.sharing.sites.push(this.shared[i]);
      }
      else {
        let ind = this.state.data.sharing.sites.indexOf(this.shared[i]);
        if (ind > -1) {
          delete this.state.data.sharing.sites[ind];
        }
      }
    }
    this.state.data.sharing.sites = this.state.data.sharing.sites.filter(function(el) {
      return el != null;
    });
    console.log(this.state.data.sharing.sites);
  }

  onActivateShare = (e) => {
    this.setState({
      isSharing: e.target.checked
    });
    if (!e.target.checked) {
      this.state.data.sharing = false;
    }
    else {
      this.state.data.sharing = {
        sites: []
      }
      this.state.sharingSites = [false, false, false, false, false, false, false, false];
    }
  }

  processPlaybackControlers(playbackRateControls) {
    if (playbackRateControls !== false && playbackRateControls[0] != '') {
      playbackRateControls = playbackRateControls.map(function(item) {
        return parseInt(item, 10);
      });
    }
    else {
      playbackRateControls = false;
    }
    return playbackRateControls;
  }

  save = async() => {
    this.setState({
      loading: true
    })
    this.state.data.playbackRateControls = this.processPlaybackControlers(this.state.data.playbackRateControls);
    /*if(this.state.data.playbackRateControls !== false && this.state.data.playbackRateControls[0] != '') {
      this.state.data.playbackRateControls = this.state.data.playbackRateControls.map(function(item) {
          return parseInt(item, 10);
      });
    }
    else {
      this.state.data.playbackRateControls = false;
    }*/
    await window.sdk.manager.saveCustom(this.props.type, window[this.props.type + 'Id'], this.state.data);
    window.sdk.emit('hideCustom');
    if (window.isVod)
      window.sdk.emit('reloadIframe');
  }
  
  delete = async() => {
    if(window.confirm('Etes vous sur ?')) {
      this.setState({
        loading: true
      })
      await window.sdk.manager.deleteCustom(this.props.type, window[this.props.type + 'Id'], this.state.data);
      window.sdk.emit('hideCustom');
      if (window.isVod)
        window.sdk.emit('reloadIframe');
    }
  }

  close = () => {
    window.sdk.emit('hideCustom');
  }

  changePlayback = (e) => {
    this.state.data.playbackRateControls = e.target.value.split(',');
    console.log(this.state.data.playbackRateControls);
    this.forceUpdate();
  }

  componentWillUnmount() {
    for (var i in this.listeners) {
      this.listeners[i]();
    }
  }


  render() {

    if (this.state.loading)
      return (
        <CircularProgress />
      )

    return (
      <Grid  container direction="row">
      
        <Grid item xs={12} align={ 'center' } style={{ position: 'fixed', background: 'rgba(255, 255, 255, 0.8)', zIndex: 100, width: '66%', textAlign: 'center' }}>
          
          <Fab onClick={ this.save } color="primary" variant="extended">
            <Save  />
            Sauvegarder
          </Fab>
          
          <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
          
          <Fab onClick={ this.delete } style={{ backgroundColor: 'red', color: '#fff' }} variant="extended">
            <Close  />
            Delete
          </Fab>
          
          <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
          
          <Fab onClick={ this.close } color="grey" variant="extended">
            <Close  />
            Close
          </Fab>
          
          
          
        </Grid>
        
        <Sepa />
        
        <Grid item xs={12}>
          <Typography variant="h6">
              Couleurs : <a href="https://material.io/tools/color/#!/" target="_blank">Outil de génération des couleurs du thème</a>
          </Typography>
        </Grid>
        
        <Grid item xs={4}>
          <TextFieldColor label={ 'Couleur primaire' } onChange={ (value) => { this.state.data.color.p1 = value } } value={ this.state.data.color.p1 } />
        </Grid>
        
        <Grid item xs={4}>
          <TextFieldColor label={ 'Couleur primaire Light' } onChange={ (value) => { this.state.data.color.p2 = value } } value={ this.state.data.color.p2 } />
        </Grid>
        
        <Grid item xs={4}>
          <TextFieldColor label={ 'Couleur primaire Dark' } onChange={ (value) => { this.state.data.color.p3 = value } } value={ this.state.data.color.p3 } />
        </Grid>
        
        <Grid item xs={4}>
          <TextFieldColor label={ 'Couleur secondaire' } onChange={ (value) => { this.state.data.color.s1 = value } } value={ this.state.data.color.s1 } />
        </Grid>
        
        <Grid item xs={4}>
          <TextFieldColor label={ 'Couleur secondaire Light' } onChange={ (value) => { this.state.data.color.s2 = value } } value={ this.state.data.color.s2 } />
        </Grid>
        
        <Grid item xs={4}>
          <TextFieldColor label={ 'Couleur secondaire Dark' } onChange={ (value) => { this.state.data.color.s3 = value } } value={ this.state.data.color.s3 } />
        </Grid>
        
        <Grid item xs={4}>
          <TextFieldColor label={ 'Couleur de fond' } onChange={ (value) => { this.state.data.color.back = value } } value={ this.state.data.color.back } />
        </Grid>
        
        <Grid item xs={4}>
          <TextFieldColor label={ 'Couleur de texte' } onChange={ (value) => { this.state.data.color.txt = value } } value={ this.state.data.color.txt } />
        </Grid>
        
        <Sepa />
        
        <Grid item xs={2}>
          <Typography variant="h6">
              Couleur du player
          </Typography>
        </Grid>
        
        <Grid item xs={10}>
          <Fab onClick={ async () => { this.state.data.playerColor = Object.assign({}, this.playerColor); await this.setState({loading: true}); setTimeout(() => { this.setState({loading: false}), 1000 }) } } color="grey" variant="extended">
            Reset
          </Fab>
        </Grid>

        <Grid item xs={3}>
          <TextFieldColor label={ 'Fond' } onChange={ (value) => { this.state.data.playerColor.controlbar = value } } value={ this.state.data.playerColor.controlbar } />
        </Grid>
        
        <Grid item xs={3}>
          <TextFieldColor label={ 'Timeline' } onChange={ (value) => { this.state.data.playerColor.slider_rail = value } } value={ this.state.data.playerColor.slider_rail } />
        </Grid>
        
        <Grid item xs={3}>
          <TextFieldColor label={ 'Timeline buffer' } onChange={ (value) => { this.state.data.playerColor.slider_buffer = value } } value={ this.state.data.playerColor.slider_buffer } />
        </Grid>
        
        <Grid item xs={3}>
          <TextFieldColor label={ 'Timeline progress' } onChange={ (value) => { this.state.data.playerColor.slider_progress = value } } value={ this.state.data.playerColor.slider_progress } />
        </Grid>
        
        <Sepa />
        
        <Grid item xs={12}>
          <Typography variant="h6">
              Les images
          </Typography>
        </Grid>
        
        
        
        <Grid item xs={12}>
          <InputFile 
            value={ this.state.data.image } 
            onChange={ (value) => { this.state.data.image = value } }
            id="file_image" 
            label={ 'Image de fond' } />
        </Grid>
        
        <Grid item xs={6}>
          <InputFile 
            value={ this.state.data.logo.file }
            onChange={ (value) => { this.state.data.logo.file = value } }
            id="file_logo" 
            label={ 'Logo' } 
          />
        </Grid>
        
        <Grid item xs={4}>
          <FormControl style={{ width: '100%' }}>
            <InputLabel htmlFor="age-simple">Emplacement du logo</InputLabel>
            <Select
              value={this.state.data.logo.position }
              onChange={ this.changeLogoPosition  }
              >
              <MenuItem value={'top-right'}>Haut droite</MenuItem>
              <MenuItem value={'bottom-right'}>Bas droite</MenuItem>
              <MenuItem value={'top-left'}>Haut gauche</MenuItem>
              <MenuItem value={'bottom-left'}>Bas gauche</MenuItem>
              <MenuItem value={'control-bar'}>Barre</MenuItem>
            </Select>
          </FormControl>
        </Grid>
        
        <Grid item xs={2}>
        </Grid>
        
        <Sepa />
        
        <Grid item xs={12}>
          <Typography variant="h6">
              Typo
          </Typography>
          
          <Grid item xs={6}>
            <TextField
              fullWidth
              label={ 'Typo balise css  <link rel="stylesheet" href="URL.css">' }
              value={ this.state.data.synople.typo }
              onChange={ (e) => { this.state.data.synople.typo = e.target.value; this.forceUpdate(); } }
              margin="normal"
              multiline={ true }
            />
          </Grid>
          
          <Grid item xs={3}>
            <TextField
              fullWidth
              label={ 'Nom de la typo' }
              value={ this.state.data.synople.typo_name }
              onChange={ (e) => { this.state.data.synople.typo_name = e.target.value; this.forceUpdate(); } }
              margin="normal"
              multiline={ true }
            />
          </Grid>
          
          <Grid item xs={3}>
            <TextField
              fullWidth
              label={ 'Taille de la typo' }
              value={ this.state.data.synople.typo_size }
              onChange={ (e) => { this.state.data.synople.typo_size = e.target.value; this.forceUpdate(); } }
              margin="normal"
              multiline={ true }
            />
          </Grid>
        
        </Grid>
        
        <Sepa />
        
        <Grid item xs={12}>
          <Typography variant="h6">
              Speaker
          </Typography>
        </Grid>
        
        <Grid item xs={4}>
          <FormControlLabel
            control={
              <Checkbox
                checked={ this.state.data.synople.speaker }
                onChange={ (e) => { this.state.data.synople.speaker = e.target.checked; this.forceUpdate() } }
                value={ true }
              />
            }
            label="Afficher le bandeau speaker"
          />
        </Grid>
        
        <Grid item xs={4}>
          <TextField
            label={ 'Délais en seconde pour l\'affichage des speaker' }
            value={ this.state.data.synople.speaker_delay }
            onChange={ (e) => { this.state.data.synople.speaker_delay = e.target.value; this.forceUpdate(); } }
            margin="normal"
          />
        </Grid>
        
        <Grid item xs={4}>
          <TextField
            label={ 'Temps en seconde d\affichage du bandeau speaker' }
            value={ this.state.data.synople.speaker_show_delay }
            onChange={ (e) => { this.state.data.synople.speaker_show_delay = e.target.value; this.forceUpdate(); } }
            margin="normal"
          />
        </Grid>
        
        
        
        <Grid item xs={6}>
          <InputFile 
            value={ this.state.data.synople.image_speaker } 
            onChange={ (value) => { this.state.data.synople.image_speaker = value } }
            id="file_speaker" 
            label={ 'Bandeau speaker (794x60)' } />
        </Grid>
        
        <Grid item xs={4}>
          <TextFieldColor label={ 'Couleur de fond' } onChange={ (value) => { this.state.data.synople.speaker_color = value } } value={ this.state.data.synople.speaker_color } />
        </Grid>
        
        <Grid item xs={4}>
          <TextFieldColor label={ 'Couleur de texte' } onChange={ (value) => { this.state.data.synople.speaker_color_txt = value } } value={ this.state.data.synople.speaker_color_txt } />
        </Grid>
        
        <Grid item xs={4}>
          <TextField
            label={ 'Espacement à gauche' }
            value={ this.state.data.synople.speaker_padding }
            onChange={ (e) => { this.state.data.synople.speaker_padding = e.target.value; this.forceUpdate(); } }
            margin="normal"
          />
        </Grid>
       
        
        <Grid item xs={8}>
          <TextField
            fullWidth
            label={ 'Typo balise css  <link rel="stylesheet" href="URL.css">' }
            value={ this.state.data.synople.speaker_typo }
            onChange={ (e) => { this.state.data.synople.speaker_typo = e.target.value; this.forceUpdate(); } }
            margin="normal"
            multiline={ true }
          />
        </Grid>
        
        <Grid item xs={4}>
          <TextField
            fullWidth
            label={ 'Nom de la typo' }
            value={ this.state.data.synople.speaker_typo_name }
            onChange={ (e) => { this.state.data.synople.speaker_typo_name = e.target.value; this.forceUpdate(); } }
            margin="normal"
            multiline={ true }
          />
        </Grid>
        
        
        <Sepa />
        
        <Grid item xs={12}>
          <Typography variant="h6">
              Options
          </Typography>
        </Grid>
        
        <Grid item xs={4}>
          <FormControlLabel
            control={
              <Checkbox
                checked={ this.state.data.synople.extraits }
                onChange={ (e) => { this.state.data.synople.extraits = e.target.checked; this.forceUpdate() } }
                value={ true }
              />
            }
            label="Afficher l'onglet extraits"
          />
        </Grid>
        
        
        
        <Grid item xs={4}>
          <FormControlLabel
            control={
              <Checkbox
                checked={ this.state.data.synople.playerOnly }
                onChange={ (e) => { this.state.data.synople.playerOnly = e.target.checked; this.forceUpdate() } }
                value={ true }
              />
            }
            label="Player seul"
          />
        </Grid>
        
        <Grid item xs={4}>
          <FormControlLabel
            control={
              <Checkbox
                checked={ this.state.data.autostart }
                onChange={ (e) => { this.state.data.autostart = e.target.checked; this.forceUpdate() } }
                value={ true }
              />
            }
            label="Autostart"
          />
        </Grid>
        
        
        <Sepa />
        
        <Grid item xs={1} >
          <Typography variant="h6">
              Partage
          </Typography>
          
        </Grid>
        
        <Grid item xs={11} style={ { marginTop: '-5px' } }>
          <Switch
           
            checked={ this.state.isSharing }
            onChange={ this.onActivateShare }
            value={ 'share' }
          />
        </Grid>
        
        { this.state.isSharing &&
          <Grid item xs={12}>
          
            { this.shared.map((name, index) => {
              return (
                <FormControlLabel
                  key={ index }
                  control={
                    <Checkbox
                      onChange={ (e) => { this.onChangeSharing(index, e.target.checked) } }
                      checked={ this.state.sharingSites[index] }
                      value={ name }
                    />
                  }
                  label={ name }
                />
              )
            })}
            
          
          </Grid>
        }
        
        <Sepa />
        
        <Grid item xs={12}>
          <Typography variant="h6">
              Choix de lecture
          </Typography>
        </Grid>
        
        <Grid item xs={3} style={ this.style.flex }>
          <FormControlLabel
            control={
              <Checkbox
                onChange={ (e) => { this.state.data.buttons.rewind.enable = e.target.checked; this.forceUpdate(); } }
                checked={ this.state.data.buttons.rewind.enable }
                value={ 'rewing' }
              />
            }
            label="Bouton retour rapide"
          />
        </Grid>
        
        <Grid item xs={3} style={ this.style.flex }>
          <TextField
            label={ 'Seconde' }
            value={ this.state.data.buttons.rewind.value }
            onChange={ (e) => { this.state.data.buttons.rewind.value = e.target.value; this.forceUpdate(); } }
            margin="normal"
          />
        </Grid>
        
        <Grid item xs={3} style={ this.style.flex }>
          <FormControlLabel
            control={
              <Checkbox
                onChange={ (e) => { this.state.data.buttons.forward.enable = e.target.checked; this.forceUpdate(); } }
                checked={ this.state.data.buttons.forward.enable }
                value={ 'rewing' }
              />
            }
            label="Bouton avance rapide"
          />
        </Grid>
        
        <Grid item xs={3} style={ this.style.flex }>
          <TextField
            label={ 'Seconde' }
            value={ this.state.data.buttons.forward.value }
            onChange={ (e) => { this.state.data.buttons.forward.value = e.target.value; this.forceUpdate(); } }
            margin="normal"
          />
        </Grid>
        
        <Grid item xs={12}>
          <TextField
            fullWidth
            label={ 'Vitesse de lecture (compris entre 0.25 et 4)' }
            value={ (this.state.data.playbackRateControls === false) ? '' : this.state.data.playbackRateControls.join(',') }
            onChange={ this.changePlayback }
            margin="normal"
          />
        </Grid>
        
        <Sepa />
        
        <Grid item xs={12}>
          <Typography variant="h6">
              Custom CSS
          </Typography>
        </Grid>
        
        <Grid item xs={12}>
          <TextField
            fullWidth
            label={ 'CSS' }
            value={ this.state.data.synople.css }
            onChange={ (e) => { this.state.data.synople.css = e.target.value; this.forceUpdate(); } }
            margin="normal"
            multiline={ true }
          />
        </Grid>
        
        <Sepa />
        
        <Grid item xs={12}>
          <Typography variant="h6">
              Custom JS
          </Typography>
        </Grid>
        
        <Grid item xs={12}>
          <TextField
            fullWidth
            label={ 'JS' }
            value={ this.state.data.synople.js }
            onChange={ (e) => { this.state.data.synople.js = e.target.value; this.forceUpdate(); } }
            margin="normal"
            multiline={ true }
          />
        </Grid>
        
        <Sepa />
        
        <Grid item xs={12} align={ 'center' }>
          
          <Fab onClick={ this.save } color="primary" variant="extended">
            <Save  />
            Sauvegarder
          </Fab>
          
          <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
          
          <Fab onClick={ this.delete } style={{ backgroundColor: 'red', color: '#fff' }} color="grey" variant="extended">
            <Close  />
            Delete
          </Fab>
          
          <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
          
          <Fab onClick={ this.close } color="grey" variant="extended">
            <Close  />
            Close
          </Fab>
          
          
          
          
          
        </Grid>
        
        
        
      </Grid>
    )
  }

}



// WEBPACK FOOTER //
// ./src/Manager/Custom/Form.js